import { render, staticRenderFns } from "./HotelFrame.vue?vue&type=template&id=0583077c&scoped=true&"
import script from "./HotelFrame.vue?vue&type=script&lang=js&"
export * from "./HotelFrame.vue?vue&type=script&lang=js&"
import style0 from "./HotelFrame.vue?vue&type=style&index=0&id=0583077c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0583077c",
  null
  
)

export default component.exports